import { NutrientType } from './NUTRIENTS_ENUM';

export const NUTRIENTS = [
  'proteins',
  'carbs',
  'fats',
  'sugar',
  'fiber',
  'sodium',
  'calories',
] satisfies NutrientType[];
